(function () {
  'use strict';

  /* ── Wishlist ───────────────────────────────────────────── */
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem('gg.wishlist') || '[]'); }
    catch (e) { return []; }
  }
  function saveWishlist(list) {
    try { localStorage.setItem('gg.wishlist', JSON.stringify(list)); } catch (e) {}
  }

  function wireHeart(btn) {
    var handle = btn.dataset.handle;
    if (getWishlist().indexOf(handle) !== -1) btn.setAttribute('aria-pressed', 'true');
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var cur = getWishlist();
      var idx = cur.indexOf(handle);
      if (idx === -1) {
        cur.push(handle);
        btn.setAttribute('aria-pressed', 'true');
      } else {
        cur.splice(idx, 1);
        btn.setAttribute('aria-pressed', 'false');
      }
      saveWishlist(cur);
    });
  }

  function initHearts() {
    document.querySelectorAll('.gg-card__heart').forEach(wireHeart);
  }

  /* ── Sort ───────────────────────────────────────────────── */
  function initSort() {
    var sel = document.getElementById('gg-sort-select');
    if (!sel) return;
    // Sync select value from URL (Liquid already marks selected, but JS keeps it in sync after AJAX)
    var current = new URLSearchParams(window.location.search).get('sort_by');
    if (current) sel.value = current;
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      window.location.assign(url.toString());
    });
  }

  /* ── Filter accordion ───────────────────────────────────── */
  function initFilterAccordion() {
    document.querySelectorAll('[data-filter-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        var body = btn.closest('[data-filter-group]').querySelector('.gg-filter-group__body');
        if (body) body.hidden = expanded;
      });
    });
  }

  /* ── Native Shopify filter form (auto-submit on change) ─── */
  function initNativeFilters() {
    var form = document.getElementById('gg-filter-form');
    if (!form) return;
    form.querySelectorAll('.gg-filter-check').forEach(function (cb) {
      cb.addEventListener('change', function () { form.submit(); });
    });
  }

  /* ── Static filters — server-rendered by Liquid ─────────── */

  function parsePriceLabel(label) {
    // Strip £, commas; normalise dash variants to "-"
    var s = label.replace(/£|,/g, '').replace(/–|—/g, '-');
    if (/under/i.test(label)) {
      var m = s.match(/\d+/);
      return m ? { max: parseInt(m[0], 10) } : {};
    }
    if (/over/i.test(label)) {
      var m = s.match(/\d+/);
      return m ? { min: parseInt(m[0], 10) } : {};
    }
    // Range: "200 - 500"
    var parts = s.match(/(\d+)[^\d]+(\d+)/);
    return parts ? { min: parseInt(parts[1], 10), max: parseInt(parts[2], 10) } : {};
  }

  function applyStaticFilters(sidebar) {
    var url = new URL(window.location.href);
    var toDelete = [];
    url.searchParams.forEach(function (v, k) {
      if (k.indexOf('filter.') === 0) toDelete.push(k);
    });
    toDelete.forEach(function (k) { url.searchParams.delete(k); });

    sidebar.querySelectorAll('.gg-static-check:checked').forEach(function (cb) {
      url.searchParams.append(cb.dataset.param, cb.dataset.value);
    });

    var priceChecked = sidebar.querySelector('.gg-static-price:checked');
    if (priceChecked) {
      var range = parsePriceLabel(priceChecked.dataset.label || '');
      if (range.min != null) url.searchParams.set('filter.v.price.gte', range.min);
      if (range.max != null) url.searchParams.set('filter.v.price.lte', range.max);
    }

    window.location.assign(url.toString());
  }

  function initStaticFilters() {
    var sidebar = document.getElementById('gg-filter-sidebar');
    if (!sidebar) return;

    var checks = sidebar.querySelectorAll('.gg-static-check');
    var prices = sidebar.querySelectorAll('.gg-static-price');
    if (!checks.length && !prices.length) return;

    // Restore checked state from current URL
    var params = new URLSearchParams(window.location.search);
    checks.forEach(function (cb) {
      var vals = params.getAll(cb.dataset.param);
      if (vals.indexOf(cb.dataset.value) !== -1) cb.checked = true;
    });
    var gteParam = params.get('filter.v.price.gte');
    var lteParam = params.get('filter.v.price.lte');
    if (gteParam || lteParam) {
      prices.forEach(function (cb) {
        var range = parsePriceLabel(cb.dataset.label || '');
        if (String(range.min || '') === String(gteParam || '') &&
            String(range.max || '') === String(lteParam || '')) {
          cb.checked = true;
        }
      });
    }

    checks.forEach(function (cb) {
      cb.addEventListener('change', function () { applyStaticFilters(sidebar); });
    });
    prices.forEach(function (cb) {
      cb.addEventListener('change', function () {
        if (cb.checked) {
          prices.forEach(function (other) { if (other !== cb) other.checked = false; });
        }
        applyStaticFilters(sidebar);
      });
    });
  }

  /* ── Show more AJAX ─────────────────────────────────────── */
  function initShowMore() {
    var btn = document.getElementById('gg-show-more');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var nextUrl = btn.dataset.nextUrl;
      if (!nextUrl) return;
      var originalText = btn.textContent;
      btn.classList.add('is-loading');
      btn.textContent = 'Loading…';

      fetch(nextUrl)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newCards = doc.querySelectorAll('.gg-card');
          var grid = document.getElementById('gg-product-grid');
          if (!grid || !newCards.length) return;

          var delay = 0;
          newCards.forEach(function (card) {
            card.classList.add('gg-card--revealing');
            grid.appendChild(card);
            var d = delay;
            setTimeout(function () {
              card.classList.remove('gg-card--revealing');
              card.classList.add('gg-card--reveal-done');
            }, d);
            delay += 12;
            var heart = card.querySelector('.gg-card__heart');
            if (heart) wireHeart(heart);
          });

          var newBtn = doc.getElementById('gg-show-more');
          if (newBtn && newBtn.dataset.nextUrl) {
            btn.dataset.nextUrl = newBtn.dataset.nextUrl;
            btn.dataset.remaining = newBtn.dataset.remaining;
            btn.textContent = 'Show more \xB7 ' + newBtn.dataset.remaining + ' remaining';
            btn.classList.remove('is-loading');
          } else {
            var wrap = document.getElementById('gg-show-more-wrap');
            if (wrap) wrap.remove();
          }

          syncShowingCount();
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          btn.textContent = originalText;
        });
    });
  }

  function syncShowingCount() {
    var span = document.getElementById('gg-showing-count');
    if (!span) return;
    var shown = document.querySelectorAll('#gg-product-grid .gg-card').length;
    span.textContent = 'Showing ' + shown + ' of ' + span.dataset.total;
    span.dataset.showing = shown;
  }

  /* ── Mobile sidebar drawer ──────────────────────────────── */
  function initMobileSidebar() {
    var openBtn  = document.getElementById('gg-filter-open');
    var closeBtn = document.getElementById('gg-filter-close');
    var sidebar  = document.getElementById('gg-filter-sidebar');
    var overlay  = document.getElementById('gg-sidebar-overlay');
    if (!sidebar) return;

    function open() {
      sidebar.classList.add('is-open');
      if (overlay) { overlay.classList.add('is-visible'); overlay.removeAttribute('aria-hidden'); }
      document.body.style.overflow = 'hidden';
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    }
    function close() {
      sidebar.classList.remove('is-open');
      if (overlay) { overlay.classList.remove('is-visible'); overlay.setAttribute('aria-hidden', 'true'); }
      document.body.style.overflow = '';
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    }

    if (openBtn)  openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay)  overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sidebar.classList.contains('is-open')) close();
    });
  }

  /* ── Filter badge count ─────────────────────────────────── */
  function initFilterBadge() {
    var badge = document.getElementById('gg-filter-badge');
    if (!badge) return;
    var count = 0;
    new URLSearchParams(window.location.search).forEach(function (v, k) {
      if (k.indexOf('filter.') === 0) count++;
    });
    if (count > 0) {
      badge.textContent = count;
      badge.removeAttribute('hidden');
    }
  }

  /* ── Init ───────────────────────────────────────────────── */
  function init() {
    initHearts();
    initSort();
    initFilterAccordion();
    initNativeFilters();
    initStaticFilters();
    initShowMore();
    initMobileSidebar();
    initFilterBadge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

}());

/* ── Price slider ──────────────────────────────────────────────
   Single-thumb range from £0 to collection's max. Live readout updates
   while dragging; URL change fires on `change` (release / arrow keys)
   so we don't reload on every micro-movement. Dragging to the maximum
   removes the param entirely → "no upper bound, show everything". */
(function () {
  'use strict';

  function setup() {
    var slider = document.querySelector('[data-price-slider]');
    if (!slider) return;
    var readout = document.querySelector('[data-price-readout]');
    var max = parseFloat(slider.getAttribute('data-max')) || parseFloat(slider.max) || 0;

    // Currency symbol + FX rate set by gg-price-slider.liquid based on
    // localization.country.currency. Defaults to GBP / 1.0 if unset.
    var wrap = slider.closest('.gg-price-slider');
    var symbol = (wrap && wrap.getAttribute('data-currency-symbol')) || '£';
    var fx     = parseFloat(wrap && wrap.getAttribute('data-currency-fx')) || 1.0;

    // Restore from URL so the thumb sits on the value the user last picked.
    // URL stores the value in the SHOP's currency (GBP), so multiply by fx
    // to display in the visitor's currency.
    try {
      var lte = new URLSearchParams(window.location.search).get('filter.v.price.lte');
      if (lte !== null && lte !== '') {
        var lteNumGbp = parseFloat(lte);
        if (Number.isFinite(lteNumGbp) && lteNumGbp >= 0) {
          var lteInCurrency = Math.round(lteNumGbp * fx);
          if (lteInCurrency >= 0 && lteInCurrency <= max) slider.value = String(lteInCurrency);
        }
      }
    } catch (e) { /* URL parse failed — keep server-rendered value */ }

    function updateFill() {
      var val = parseFloat(slider.value) || 0;
      var pct = max > 0 ? Math.round((val / max) * 100) : 100;
      slider.style.setProperty('--gg-fill-pct', pct + '%');
      if (readout) readout.textContent = symbol + val;
    }

    function commit() {
      var val = parseFloat(slider.value) || 0;
      // URL filter is always in the SHOP currency (GBP). Convert back from
      // the visitor's currency before writing the param so Shopify's filter
      // semantics line up with how products are priced internally.
      var valGbp = fx > 0 ? Math.round(val / fx) : val;
      var url = new URL(window.location.href);
      url.searchParams.delete('filter.v.price.gte');
      if (val >= max) {
        url.searchParams.delete('filter.v.price.lte');
      } else {
        url.searchParams.set('filter.v.price.lte', valGbp);
      }
      window.location.assign(url.toString());
    }

    slider.addEventListener('input', updateFill);
    slider.addEventListener('change', commit);
    updateFill();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
}());
